import React from 'react';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="py-24 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-black text-slate-900 mb-8">Política de Privacidad</h1>
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-6">Última actualización: Mayo 2026</p>
          
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">1. Identificación del Responsable</h2>
            <p className="text-slate-600">ANCORA AUTOMATIONS es el responsable del tratamiento de tus datos personales.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">2. Datos Personales que Recopilamos</h2>
            <h3 className="font-semibold mb-2 text-slate-800">2.1. Datos de Contacto:</h3>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-slate-600">
              <li>Nombre y apellidos</li>
              <li>Dirección de correo electrónico</li>
              <li>Número de teléfono</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">3. Finalidad del Tratamiento de Datos</h2>
            <p className="text-slate-600">Gestionar solicitudes de contacto, proporcionar servicios contratados y mejorar nuestros servicios.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Tus Derechos</h2>
            <p className="text-slate-600">Derechos de Acceso, Rectificación, Supresión, Oposición, Limitación del tratamiento y Portabilidad.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">5. Contacto</h2>
            <p className="text-slate-600">Email: automatiza@ancoraautomations.es</p>
            <p className="text-slate-600">Teléfono: +34 614 04 63 52</p>
          </section>
        </div>
      </div>
    </div>
  );
};
